var _regeneratorRuntime = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/regenerator/index.js");

var _toConsumableArray = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _objectWithoutProperties = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _asyncToGenerator = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _inherits = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/galaxy-nft/galaxy-nft/node_modules/@babel/runtime/helpers/createClass.js");

var _excluded = ["client", "children", "persistOptions", "onSuccess"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("core-js/modules/esnext.global-this.js");

/**
 * react-query-persist-client
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("@tanstack/react-query")) : "function" == typeof define && define.amd ? define(["exports", "react", "@tanstack/react-query"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).ReactQueryPersistClient = {}, e.React, e.ReactQuery);
}(this, function (e, t, n) {
  "use strict";

  function s(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function (n) {
      if ("default" !== n) {
        var s = Object.getOwnPropertyDescriptor(e, n);
        Object.defineProperty(t, n, s.get ? s : {
          enumerable: !0,
          get: function get() {
            return e[n];
          }
        });
      }
    }), t.default = e, Object.freeze(t);
  }

  var i = s(t);
  /**
     * query-core
     *
     * Copyright (c) TanStack
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE.md file in the root directory of this source tree.
     *
     * @license MIT
     */

  var r = /*#__PURE__*/function () {
    function r() {
      _classCallCheck(this, r);

      this.listeners = [], this.subscribe = this.subscribe.bind(this);
    }

    _createClass(r, [{
      key: "subscribe",
      value: function subscribe(e) {
        var _this = this;

        return this.listeners.push(e), this.onSubscribe(), function () {
          _this.listeners = _this.listeners.filter(function (t) {
            return t !== e;
          }), _this.onUnsubscribe();
        };
      }
    }, {
      key: "hasListeners",
      value: function hasListeners() {
        return this.listeners.length > 0;
      }
    }, {
      key: "onSubscribe",
      value: function onSubscribe() {}
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {}
    }]);

    return r;
  }();

  var u = "undefined" == typeof window;
  new ( /*#__PURE__*/function (_r) {
    _inherits(_class, _r);

    var _super = _createSuper(_class);

    function _class() {
      var _this2;

      _classCallCheck(this, _class);

      _this2 = _super.call(this), _this2.setup = function (e) {
        if (!u && window.addEventListener) {
          var _t = function _t() {
            return e();
          };

          return window.addEventListener("visibilitychange", _t, !1), window.addEventListener("focus", _t, !1), function () {
            window.removeEventListener("visibilitychange", _t), window.removeEventListener("focus", _t);
          };
        }
      };
      return _this2;
    }

    _createClass(_class, [{
      key: "onSubscribe",
      value: function onSubscribe() {
        this.cleanup || this.setEventListener(this.setup);
      }
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {
        var e;
        this.hasListeners() || (null == (e = this.cleanup) || e.call(this), this.cleanup = void 0);
      }
    }, {
      key: "setEventListener",
      value: function setEventListener(e) {
        var _this3 = this;

        var t;
        this.setup = e, null == (t = this.cleanup) || t.call(this), this.cleanup = e(function (e) {
          "boolean" == typeof e ? _this3.setFocused(e) : _this3.onFocus();
        });
      }
    }, {
      key: "setFocused",
      value: function setFocused(e) {
        this.focused = e, e && this.onFocus();
      }
    }, {
      key: "onFocus",
      value: function onFocus() {
        this.listeners.forEach(function (e) {
          e();
        });
      }
    }, {
      key: "isFocused",
      value: function isFocused() {
        return "boolean" == typeof this.focused ? this.focused : "undefined" == typeof document || [void 0, "visible", "prerender"].includes(document.visibilityState);
      }
    }]);

    return _class;
  }(r))();

  function o(e) {
    return e.state.isPaused;
  }

  function a(e) {
    return "success" === e.state.status;
  }

  function c(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var n = [],
        s = [];

    if (!1 !== t.dehydrateMutations) {
      var _s = t.shouldDehydrateMutation || o;

      e.getMutationCache().getAll().forEach(function (e) {
        _s(e) && n.push(function (e) {
          return {
            mutationKey: e.options.mutationKey,
            state: e.state
          };
        }(e));
      });
    }

    if (!1 !== t.dehydrateQueries) {
      var _n = t.shouldDehydrateQuery || a;

      e.getQueryCache().getAll().forEach(function (e) {
        _n(e) && s.push(function (e) {
          return {
            state: e.state,
            queryKey: e.queryKey,
            queryHash: e.queryHash
          };
        }(e));
      });
    }

    return {
      mutations: n,
      queries: s
    };
  }

  function l(_x) {
    return _l.apply(this, arguments);
  }

  function _l() {
    _l = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var e, t, _ref$maxAge, n, _ref$buster, s, i, _r3, _u, _o;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e = _ref.queryClient, t = _ref.persister, _ref$maxAge = _ref.maxAge, n = _ref$maxAge === void 0 ? 864e5 : _ref$maxAge, _ref$buster = _ref.buster, s = _ref$buster === void 0 ? "" : _ref$buster, i = _ref.hydrateOptions;
              _context.prev = 1;
              _context.next = 4;
              return t.restoreClient();

            case 4:
              _r3 = _context.sent;
              if (_r3) if (_r3.timestamp) {
                _u = Date.now() - _r3.timestamp > n, _o = _r3.buster !== s;
                _u || _o ? t.removeClient() : function (e, t, n) {
                  if ("object" != typeof t || null === t) return;
                  var s = e.getMutationCache(),
                      i = e.getQueryCache(),
                      r = t.mutations || [],
                      u = t.queries || [];
                  r.forEach(function (t) {
                    var i;
                    s.build(e, _objectSpread(_objectSpread({}, null == n || null == (i = n.defaultOptions) ? void 0 : i.mutations), {}, {
                      mutationKey: t.mutationKey
                    }), t.state);
                  }), u.forEach(function (t) {
                    var s;
                    var r = i.get(t.queryHash);
                    r ? r.state.dataUpdatedAt < t.state.dataUpdatedAt && r.setState(t.state) : i.build(e, _objectSpread(_objectSpread({}, null == n || null == (s = n.defaultOptions) ? void 0 : s.queries), {}, {
                      queryKey: t.queryKey,
                      queryHash: t.queryHash
                    }), t.state);
                  });
                }(e, _r3.clientState, i);
              } else t.removeClient();
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              t.removeClient();

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _l.apply(this, arguments);
  }

  function d(_x2) {
    return _d.apply(this, arguments);
  }

  function _d() {
    _d = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var e, t, _ref2$buster, n, s, i;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e = _ref2.queryClient, t = _ref2.persister, _ref2$buster = _ref2.buster, n = _ref2$buster === void 0 ? "" : _ref2$buster, s = _ref2.dehydrateOptions;
              i = {
                buster: n,
                timestamp: Date.now(),
                clientState: c(e, s)
              };
              _context2.next = 4;
              return t.persistClient(i);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _d.apply(this, arguments);
  }

  function h(e) {
    var t = e.queryClient.getQueryCache().subscribe(function () {
      d(e);
    }),
        n = e.queryClient.getMutationCache().subscribe(function () {
      d(e);
    });
    return function () {
      t(), n();
    };
  }

  function f(e) {
    var t,
        n = !1;
    return [function () {
      n = !0, null == t || t();
    }, l(e).then(function () {
      n || (t = h(e));
    })];
  }

  function p() {
    return p = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var s in n) {
          Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
        }
      }

      return e;
    }, p.apply(this, arguments);
  }

  new ( /*#__PURE__*/function (_r2) {
    _inherits(_class2, _r2);

    var _super2 = _createSuper(_class2);

    function _class2() {
      var _this4;

      _classCallCheck(this, _class2);

      _this4 = _super2.call(this), _this4.setup = function (e) {
        if (!u && window.addEventListener) {
          var _t2 = function _t2() {
            return e();
          };

          return window.addEventListener("online", _t2, !1), window.addEventListener("offline", _t2, !1), function () {
            window.removeEventListener("online", _t2), window.removeEventListener("offline", _t2);
          };
        }
      };
      return _this4;
    }

    _createClass(_class2, [{
      key: "onSubscribe",
      value: function onSubscribe() {
        this.cleanup || this.setEventListener(this.setup);
      }
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {
        var e;
        this.hasListeners() || (null == (e = this.cleanup) || e.call(this), this.cleanup = void 0);
      }
    }, {
      key: "setEventListener",
      value: function setEventListener(e) {
        var _this5 = this;

        var t;
        this.setup = e, null == (t = this.cleanup) || t.call(this), this.cleanup = e(function (e) {
          "boolean" == typeof e ? _this5.setOnline(e) : _this5.onOnline();
        });
      }
    }, {
      key: "setOnline",
      value: function setOnline(e) {
        this.online = e, e && this.onOnline();
      }
    }, {
      key: "onOnline",
      value: function onOnline() {
        this.listeners.forEach(function (e) {
          e();
        });
      }
    }, {
      key: "isOnline",
      value: function isOnline() {
        return "boolean" == typeof this.online ? this.online : "undefined" == typeof navigator || void 0 === navigator.onLine || navigator.onLine;
      }
    }]);

    return _class2;
  }(r))();
  e.PersistQueryClientProvider = function (_ref3) {
    var e = _ref3.client,
        t = _ref3.children,
        s = _ref3.persistOptions,
        r = _ref3.onSuccess,
        u = _objectWithoutProperties(_ref3, _excluded);

    var _i$useState = i.useState(!0),
        _i$useState2 = _slicedToArray(_i$useState, 2),
        o = _i$useState2[0],
        a = _i$useState2[1],
        c = i.useRef({
      persistOptions: s,
      onSuccess: r
    });

    return i.useEffect(function () {
      c.current = {
        persistOptions: s,
        onSuccess: r
      };
    }), i.useEffect(function () {
      var t = !1;
      a(!0);

      var _f = f(_objectSpread(_objectSpread({}, c.current.persistOptions), {}, {
        queryClient: e
      })),
          _f2 = _slicedToArray(_f, 2),
          n = _f2[0],
          s = _f2[1];

      return s.then(function () {
        t || (null == c.current.onSuccess || c.current.onSuccess(), a(!1));
      }), function () {
        t = !0, n();
      };
    }, [e]), i.createElement(n.QueryClientProvider, p({
      client: e
    }, u), i.createElement(n.IsRestoringProvider, {
      value: o
    }, t));
  }, e.persistQueryClient = f, e.persistQueryClientRestore = l, e.persistQueryClientSave = d, e.persistQueryClientSubscribe = h, e.removeOldestQuery = function (_ref4) {
    var e = _ref4.persistedClient;

    var t = _toConsumableArray(e.clientState.mutations),
        n = _toConsumableArray(e.clientState.queries),
        s = _objectSpread(_objectSpread({}, e), {}, {
      clientState: {
        mutations: t,
        queries: n
      }
    }),
        i = _toConsumableArray(n).sort(function (e, t) {
      return e.state.dataUpdatedAt - t.state.dataUpdatedAt;
    });

    if (i.length > 0) {
      var _e = i.shift();

      return s.clientState.queries = n.filter(function (t) {
        return t !== _e;
      }), s;
    }
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});